interface Unsubscribe {
  (): void;
}

export class CallbacksPool<TPayloadType extends any[] = []> {
  private _pool = new Array<(...payload: TPayloadType) => void>();

  get size() {
    return this._pool.length;
  }

  add = (callback: (...payload: TPayloadType) => void): Unsubscribe => {
    this._pool.push(callback);

    return () => this.remove(callback);
  };

  remove = (callback: (...payload: TPayloadType) => void) => {
    const indexOfCallback = this._pool.indexOf(callback);

    if (indexOfCallback !== -1) {
      this._pool.splice(indexOfCallback, 1);
    }
  };

  clear = () => {
    this._pool.length = 0;
  };

  invoke = (...payload: TPayloadType) => {
    this._pool.forEach(callback => callback(...payload));
  };
}
